import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Bell } from "lucide-react";

export default function Collections() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/sales/collections"); setItems(data); };
  useEffect(() => { load(); }, []);

  const remind = async (inv) => {
    try { const { data } = await api.post(`/sales/collections/${inv.id}/remind`); toast.success(data.message); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sales-collections">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Collections</h1>
        <p className="text-muted-foreground">Outstanding customer invoices with one-click reminder. Accounts team is notified automatically.</p>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Invoice</TableHead><TableHead>Customer</TableHead><TableHead>Total</TableHead><TableHead>Balance</TableHead><TableHead>Due</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Actions</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((i) => (
              <TableRow key={i.id} data-testid={`collection-row-${i.id}`}>
                <TableCell className="font-mono text-xs">{i.number}</TableCell>
                <TableCell>{i.customer_name || i.party_name || "—"}</TableCell>
                <TableCell>₹{(i.total || 0).toLocaleString()}</TableCell>
                <TableCell className="font-semibold">₹{(i.balance ?? i.total ?? 0).toLocaleString()}</TableCell>
                <TableCell className="font-mono text-xs">{i.due_date || "—"}</TableCell>
                <TableCell><Badge variant="outline">{i.status || "OPEN"}</Badge></TableCell>
                <TableCell className="text-right"><Button size="sm" onClick={() => remind(i)} data-testid={`collection-remind-${i.id}`}><Bell className="w-4 h-4 mr-1" /> Remind</Button></TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-10">No outstanding receivables.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
